import React from 'react';

// The ShopFlex logo set in type, so it stays sharp at any size.
// Swap for an SVG of the original logo when one is available.
export default function Wordmark({ className = '', size = 'text-[1.375rem]' }) {
  return (
    <span className={`inline-flex flex-col leading-none text-ink ${className}`} dir="ltr">
      <span className={`font-wordmark font-black tracking-[-0.01em] ${size}`}>SHOPFLEX.</span>
      <span className="ms-[14%] mt-[0.2em] font-label text-[0.42em] font-semibold tracking-[0.32em]" style={{ fontSize: '0.5rem' }}>
        STUDIOS
      </span>
    </span>
  );
}
